export default "__VITE_ASSET__YeCYdX1t__"